// extracted by mini-css-extract-plugin
export default {"content-wrapper":"styles_content-wrapper__CXGJf","fullView":"styles_fullView__wu3vx","shimmer":"styles_shimmer__7FFgs"};